import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { get } from '../../services/api.service';
import { FetchUserProps, UserEnum, IUser, LoadingState, LoadingStateType } from '../interface';

export const fetchUserInfo = createAsyncThunk('user/fetchById', async ({ userType, id }: FetchUserProps) => {
	let endpoint = '/api/biz/';
	if (userType === UserEnum.OUTLET) {
		endpoint += `outlets/${id}`;
	} else {
		endpoint += `pos/${id}`;
	}
	const response = await get(endpoint + '/pwa');
	return response;
});

export interface UserState {
	user: IUser;
	loading: LoadingStateType;
}

const initialState = {
	user: {
		_id: '',
		name: '',
		allowRefundAtOutletAndPOS: false,
		outletName: '',
		merchant: {
			earnRates: {
				amountBlock: 0,
				base: 0,
			},
			_id: '',
			brand: '',
			earn: false,
			burn: false,
			acceptedCurrencyCode: '',
			view: '',
			countryCode: '',
			payByCard: false,
		},
	},
	loading: LoadingState.IDLE,
} satisfies UserState as UserState;

const userSlice = createSlice({
	name: 'user',
	initialState: initialState,
	reducers: {
		getUserInfo: (state, action: PayloadAction<UserState>) => {
			return {
				...state.user,
				...action.payload,
			};
		},
	},
	extraReducers(builder) {
		builder.addCase(fetchUserInfo.pending, (state: UserState) => {
			state.loading = LoadingState.PENDING;
		});
		builder.addCase(fetchUserInfo.fulfilled, (state: UserState, action) => {
			state.loading = LoadingState.SUCCESSED;
			if (action?.payload?.data) state.user = action.payload.data;
		});
		builder.addCase(fetchUserInfo.rejected, (state: UserState) => {
			state.loading = LoadingState.FAILED;
		});
	},
});

export const userReducer = userSlice.reducer;
export default userSlice;
